import { ClaimStatusCard } from "./components/ClaimStatusCard";
import { FAQCard } from "./components/FAQCard";
import { RaiseNewClaimCard } from "./components/RaiseNewClaimCard";

export const CLAIM_COMPONENT_MAPPER = {
  left: {
    RaiseNewClaimCard: RaiseNewClaimCard,
    FAQCard: FAQCard,
  },
  right: {
    ClaimStatusCard: ClaimStatusCard,
  },
} as const;
